import { render, staticRenderFns } from "./KaspiForm.vue?vue&type=template&id=af0b1d78&"
import script from "./KaspiForm.vue?vue&type=script&lang=js&"
export * from "./KaspiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports